import { render, staticRenderFns } from "./ParentSaid.vue?vue&type=template&id=fd482b0a&scoped=true"
import script from "./ParentSaid.vue?vue&type=script&lang=js"
export * from "./ParentSaid.vue?vue&type=script&lang=js"
import style0 from "./ParentSaid.vue?vue&type=style&index=0&id=fd482b0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd482b0a",
  null
  
)

export default component.exports